export function encodeUndefined(): void {
}
